import StarRating from './component';
import { COLOR_TABLE } from './consts';
import { Star } from './Star';

export default StarRating;

export { COLOR_TABLE, Star };
